import Form from "components/Form";
import {
  SOS_STATUS,
  SOS_URL,
  TRANSLATION_DISCLAIMER_MESSAGE,
  URLS,
} from "configs/constants";
import React from "react";
import { useParams } from "react-router-dom";
import RecordTable from "./RecordTable";
// import SOSTranslation from "./SOSTranslation";
import TranslationDetails from "./TranslationDetails";

const initialValues = {
  status: "",
  attended_by: "",
  attended_date: null,
  attended_time: null,
  remarks: "",
};

function SOSDetail() {
  const params = useParams();
  const formButtons = ["cancel"];

  const formFields = [
    { type: "title", title: "Employee Details" },
    {
      type: "renderonly",
      label: "Employee ID",
      key: "worker_id",
    },
    {
      type: "renderonly",
      label: "Employee Name",
      key: "worker_name",
    },
    { type: "renderonly", label: "Mobile Number", key: "mobile_number" },
    {
      type: "renderonly",
      label: "Supervisor",
      key: "supervisor",
    },
    { type: "renderonly", label: "Nationality", key: "nationality" },
    { type: "renderonly", label: "Company", key: "company" },
    { type: "renderonly", label: "Zone", key: "zone" },
    { type: "renderonly", label: "Region", key: "region" },
    { type: "renderonly", label: "Estate", key: "estate" },
    { type: "renderonly", label: "Division", key: "division" },
    { type: "renderonly", label: "Block", key: "block" },

    { type: "title", title: "SOS Details" },
    { type: "renderonly", label: "SOS ID", key: "sos_id" },
    {
      type: "renderonly",
      label: "Server Date-Time",
      key: "created_at",
      valueType: "date_time",
    },
    {
      type: "renderonly",
      label: "Mobile Date-Time",
      key: "mobile_date_time",
      valueType: "date_time",
    },
    {
      type: "renderonly",
      label: "Download Audio",
      key: "audio_download",
      valueType: "link",
      authClick: true,
      linkWrapper: "sos_id",
      linkWrapperText: "audio",
    },
    {
      type: "audio",
      key: "audio_play",
      label: "Play Audio",
    },
    {
      type: "renderonly",
      label: "Location",
      key: "location_link",
      valueType: "link",
      authClick: true,
      linkWrapper: "location_text",
      linkWrapperText: "location",
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      proxyUrl: SOS_STATUS,
      paginated: false,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "renderonly",
      name: "attended_by",
      label: "Attended By",
      key: "attended_by",
      proxyUrl: params.id ? `sos/${params.id}/attendees/` : null,
      paginated: false,
      required: true,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "renderonly",
      name: "attended_date",
      label: "Attended Date",
      key: "attended_date",
      required: true,
      size: "small",
      maxDate: new Date(),
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
    },
    {
      type: "renderonly",
      name: "attended_time",
      label: "Attended Time",
      key: "attended_time",
      size: "small",
      autoComplete: "off",
      helperText: "",
      emptyLabel: "",
      gridSize: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 3,
      },
      required: true,
    },
    {
      type: "renderonly",
      size: "medium",
      name: "remarks",
      label: "Remarks",
      key: "remarks",
      variant: "outlined",
      multiline: true,
      inputProps: { maxLength: 250 },
      rows: 3,
      gridSize: { xs: 12, sm: 12 },
    },
    {
      type: "title",
      title: "Previous Translation Details",
      showInfoIcon: true,
      infoContent: TRANSLATION_DISCLAIMER_MESSAGE,
    },
    {
      type: "component",
      component: TranslationDetails,
      passValueWithKey: "translations",
      gridSize: { xs: 12 },
    },
    { type: "title", title: "Access History" },
    {
      type: "component",
      component: RecordTable,
      key: "audio_downloaded_by",
      title: "Who Downloaded The Audio?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: "Date and Time" },
        { field: "name", name: "Name" },
      ],
    },
    {
      type: "component",
      component: RecordTable,
      key: "audio_played_by",
      title: "Who Played The Audio?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: "Date and Time" },
        { field: "name", name: "Name" },
      ],
    },
    {
      type: "component",
      component: RecordTable,
      key: "link_clicked_by",
      title: "Who Clicked The Link Location?",
      gridSize: { xs: 12 },
      columns: [
        { field: "id", name: "No." },
        { field: "datetime", name: "Date and Time" },
        { field: "name", name: "Name" },
      ],
    },
  ];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={SOS_URL}
      formFields={formFields}
      listRoute={URLS.SOS_LIST}
      formButtons={formButtons}
      formTitle="SOS"
      noTypography
    />
  );
}

export default SOSDetail;
